import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Menu,
  MenuItem,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import FilterIcon from "@mui/icons-material/Tune";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  StyledContainer,
  CapsuleValue,
  paginationStyles,
} from "../../components/style";
import { getColumnWidth } from "../../../style/datagridMQ";
import CustomDataGrid from "../../constant/commondatagrid";
import { CircleLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { customerViewAllRequest } from "../../../redux/customer/CustomerAction";

const columns = () => [
  {
    field: "first_name",
    headerName: "First Name",
    width: getColumnWidth("column"),
  },
  {
    field: "last_name",
    headerName: "Last Name",
    width: getColumnWidth("column"),
  },
  { field: "email", headerName: "Email", width: getColumnWidth("column") },
  { field: "phone", headerName: "Phone No", width: getColumnWidth("column") },
  {
    field: "dob",
    headerName: "Date Of Birth",
    width: getColumnWidth("column"),
  },
  {
    field: "ViewTransactionDetails",
    headerName: "View Transaction Details",
    width: getColumnWidth("column"),
    renderCell: (params) => (
      <a
        href={params.value}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "#000", textAlign: "center" }}
      >
        link
      </a>
    ),
  },
  {
    field: "LastOrder",
    headerName: "Last Order",
    width: getColumnWidth("column"),
    renderCell: (params) => (
      <CapsuleValue readonly>{"$465"}</CapsuleValue>
    ),
  },
];

const GeneralCustomers = () => {
  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [emptyList, setEmptyList] = useState([]);


  const dispatch = useDispatch();
  const customerViewAllState = useSelector(
    (state) => state.customer?.viewAllCustomer || {}
  );
  const customerList = customerViewAllState?.data || [];
  const totalRecords = customerViewAllState?.totalRecords || 0;
  const customerPageSize = customerViewAllState?.pageSize || 10;
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(customerViewAllRequest());
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (customerViewAllState?.success) {
      setRows(customerList);
      setOriginalRows(customerList);
    } else {
      setRows(emptyList);
      setOriginalRows([]);
    }
  }, [customerViewAllState]);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    let filteredRows = [...originalRows];

    switch (condition) {
      case "Condition 1":
        filteredRows.sort((a, b) => a.first_name.localeCompare(b.first_name));
        break;
      case "Condition 2":
        // filteredRows.sort((a, b) => {
        //   const orderA = parseFloat(a.LastOrder.replace(/[^0-9.-]+/g, "")) || 0;
        //   const orderB = parseFloat(b.LastOrder.replace(/[^0-9.-]+/g, "")) || 0;
        //   return orderB - orderA;
        // });
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }

    setRows(filteredRows);
    handleFilterClose();
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={9}>
          <Box>
            <h1>Customers</h1>
            <p>Here is the complete list of Customers data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={4} xl={3}>
          <Button
            variant="contained"
            startIcon={<FilterIcon color="blue" />}
            endIcon={<ExpandMoreIcon />}
            onClick={handleFilterClick}
            sx={{
              backgroundColor: "#f4f5f9",
              color: "#999ea5",
              marginTop: "20px",
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>

      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem onClick={() => handleFilterCondition("Condition 1")}>
            UserName A-Z
          </MenuItem>
          <MenuItem onClick={() => handleFilterCondition("Condition 2")}>
            Last order higher to lower
          </MenuItem>
        </Menu>

        {customerViewAllState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1000}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={customerViewAllState?.inProgress}
                size={50}
                color="#0458d3"
              />
            </Box>
          </Box>
        )}

        {!customerViewAllState?.inProgress && (
          <>
            <Paper>
              <CustomDataGrid
                rows={rows}
                columns={columns()}
                pageSize={customerPageSize}
                pagination={true}
                rowHeight={70}
              />
            </Paper>

            <Box mt={2}>
              <Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <Typography
                    variant="body1"
                    component="p"
                    textAlign={"start"}
                    marginTop={6}
                  >
                    Showing {customerPageSize} from {totalRecords} data
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Box
                    className="button-box"
                    padding={{ xs: 1, sm: 3 }}
                    display="flex"
                    justifyContent="end"
                  >
                    <Button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      sx={paginationStyles.PreviousButton}
                    >
                      Previous
                    </Button>
                    <Box sx={{ backgroundColor: "#e3e4eb" }}>
                      {Array.from(
                        {
                          length: Math.min(
                            Math.ceil(totalRecords / customerPageSize),
                            3
                          ),
                        },
                        (_, i) => i + 1
                      ).map((pageNumber) => (
                        <Button
                          key={pageNumber}
                          onClick={() => setCurrentPage(pageNumber)}
                          sx={{
                            backgroundColor:
                              currentPage === pageNumber ? "#fff" : "#e3e4eb",
                            color:
                              currentPage === pageNumber ? "#000" : "#b6bee8",
                            ...paginationStyles.arrayButtons,
                          }}
                        >
                          {pageNumber}
                        </Button>
                      ))}
                    </Box>
                    <Button
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            Math.ceil(totalRecords / customerPageSize)
                          )
                        )
                      }
                      sx={paginationStyles.nextButton}
                    >
                      Next
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </StyledContainer>
    </>
  );
};

export default GeneralCustomers;
